module.exports = __webpack_public_path__ + "img/video-2.12af58c6.jpg";